import { SVGProps } from 'react';

export default function ClipboardDocumentIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = '#444D5A', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M16.6654 6.87499V15C16.6654 17.5 15.1737 18.3333 13.332 18.3333H6.66536C4.8237 18.3333 3.33203 17.5 3.33203 15V6.87499C3.33203 4.16666 4.8237 3.54166 6.66536 3.54166C6.66536 4.05832 6.87368 4.52499 7.21534 4.86665C7.55701 5.20832 8.0237 5.41666 8.54036 5.41666H11.457C12.4904 5.41666 13.332 4.57499 13.332 3.54166C15.1737 3.54166 16.6654 4.16666 16.6654 6.87499Z'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3346 3.54166C13.3346 4.57499 12.493 5.41666 11.4596 5.41666H8.54297C8.0263 5.41666 7.55961 5.20832 7.21795 4.86665C6.87628 4.52499 6.66797 4.05832 6.66797 3.54166C6.66797 2.50832 7.50964 1.66666 8.54297 1.66666H11.4596C11.9763 1.66666 12.443 1.87499 12.7847 2.21666C13.1263 2.55833 13.3346 3.02499 13.3346 3.54166Z'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66797 10.8333H10.0013'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66797 14.1667H13.3346'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
